import React, {useContext} from 'react';
import {IntlProvider, useIntl} from 'react-intl';

import AppLocale from '../../shared/localization';
import AppContext from './AppContext';
import AppContextPropsType from '../../types/AppContextPropsType';
import {IntlGlobalProvider} from './Utils';

const LocaleProvider = (props: any) => {
  const {locale} = useContext<AppContextPropsType>(AppContext);
  const currentAppLocale = AppLocale[locale.locale];

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      defaultLocale='it'
      messages={currentAppLocale.messages}>
      <IntlGlobalProvider>{props.children}</IntlGlobalProvider>
    </IntlProvider>
  );
};

export default LocaleProvider;

export type IntlDictionary<L extends keyof typeof AppLocale = "it"> = keyof typeof AppLocale[L]['messages'];

export const useIntlMesssages = () => {
  return useIntl().messages as unknown as Record<IntlDictionary, string>;
};
/*
type RecursiveKeys<T> = {
  [K in keyof T]: string;
}

type DottedPropsNotation<T> = T extends string ? T : (`${T}.${keyof T}`)
*/
//type RecursiveKeys2<T> = T extends string ? T : `${T}`

/** THIS ONE WORKS */
/*
type RemoveStartingDot<T> = T extends string ? (T extends `.${infer P}` ? P  : T) : never;
type DotConcat<X,Y> = RemoveStartingDot<`${X & string}.${Y & string}`>;

type DottedPropsNotation<T, Prefix = ''> = T extends string ? (T extends `${infer K}.${infer P}` ? Record<K, DottedPropsNotation<P, DotConcat<Prefix, K>>> : Record<T, DotConcat<Prefix, T>>) : never;
*/
